// extracted by mini-css-extract-plugin
module.exports = {"status":"_fb71260","scoreboard":"_6524957","eventStartDate":"_ea58de4","scoreboardContainer":"_c75ddb6"};